export default [
	{
        "id": 1,
        "name": "葡萄",
        "desc": "云南葡萄夏黑葡萄提子 新鲜水果 2斤 颗粒装",
        "price0": 29.90,
        "price1": 29.90,
        "specification": "1000g",
        "producingArea": "云南",
        "imgName": "1.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 2,
        "name": "苹果",
        "desc": "冰糖心苹果 5斤装约12个 生鲜红富士 新鲜水果中小果",
        "price0": 45.00,
        "price1": 43.90,
        "specification": "5斤装",
        "producingArea": "新疆",
        "imgName": "2.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 3,
        "name": "橙子",
        "desc": "西班牙 进口脐橙大果2kg装 单果重约180-210g 新鲜橙子水果",
        "price0": 39.90,
        "price1": 39.90,
        "specification": "2kg",
        "producingArea": "西班牙",
        "imgName": "3.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 4,
        "name": "车厘子",
        "desc": "大连美早大樱桃 车厘子 新鲜采摘生鲜 2斤",
        "price0": 115.90,
        "price1": 109.90,
        "specification": "1kg",
        "producingArea": "大连",
        "imgName": "4.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 5,
        "name": "柠檬",
        "desc": "四川安岳黄柠檬一级大果 京东新鲜水果大果 5斤装",
        "price0": 22.90,
        "price1": 22.90,
        "specification": "5斤",
        "producingArea": "四川",
        "imgName": "5.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 6,
        "name": "百香果",
        "desc": "广西百香果 5斤大果 新鲜水果 单果60-100g",
        "price0": 58.90,
        "price1": 54.90,
        "specification": "5斤",
        "producingArea": "广西",
        "imgName": "6.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 7,
        "name": "梨子",
        "desc": "安徽 现摘砀山酥梨5kg新鲜梨子水果非雪梨贡梨丰水梨香梨10斤新鲜水果",
        "price0": 48.90,
        "price1": 48.90,
        "specification": "10斤",
        "producingArea": "安徽",
        "imgName": "7.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 8,
        "name": "番石榴",
        "desc": "广西红心芭乐番石榴 2.5kg 新鲜水果 5斤装",
        "price0": 26.90,
        "price1": 26.90,
        "specification": "5斤",
        "producingArea": "广西",
        "imgName": "8.jpg",       
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 95142,
        "commentNum": 8753,
    },
    {
        "id": 9,
        "name": "菠萝",
        "desc": "香水大菠萝 新鲜水果 非凤梨 送菠萝刀 净果9斤【单果500-1500g】",
        "price0": 29.90,
        "price1": 29.90,
        "specification": "9斤",
        "producingArea": "广西",
        "imgName": "9.jpg",        
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 77843,
        "commentNum": 8753,
    },
    {
        "id": 10,
        "name": "香蕉",
        "desc": "广西农家香甜香蕉 新鲜水果 4.5kg",
        "price0": 35.90,
        "price1": 35.90,
        "specification": "4.5斤",
        "producingArea": "广西",
        "imgName": "10.jpg",
        "category": "新鲜水果",
        "brand": "鲜绿水果",
        "saleNum": 65982,
        "commentNum": 8753,
    },
    {
        "id": 11,
        "name": "三文鱼",
        "desc": "冷冻智利三文鱼刺身（大西洋鲑） 500g 生鱼片",
        "price0": 49.90,
        "price1": 49.90,
        "specification": "500g",
        "producingArea": "智利",
        "imgName": "11.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 12,
        "name": "大闸蟹",
        "desc": "蟹知香长荡湖大闸蟹礼盒 现货(公3.8-3.3两 母2.7-2.3两)8只",
        "price0": 199.00,
        "price1": 190.90,
        "specification": "2只",
        "producingArea": "湖南",
        "imgName": "12.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 13,
        "name": "生蚝",
        "desc": "乳山生蚝5斤27/32只 鲜活海蛎子牡蛎 冷水蚝 保肥",
        "price0": 68.00,
        "price1": 68.90,
        "specification": "5斤",
        "producingArea": "国产",
        "imgName": "13.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 14,
        "name": "小龙虾",
        "desc": "麻辣小龙虾尾1000g 120-140只 盒装 海鲜龙虾球",
        "price0": 89.90,
        "price1": 89.90,
        "specification": "1kg",
        "producingArea": "国产",
        "imgName": "14.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 15,
        "name": "鳕鱼",
        "desc": "冰岛野生大西洋真鳕鱼 深海捕捞 去皮去刺鳕鱼中段400g（2块装）",
        "price0": 139.90,
        "price1": 129.90,
        "specification": "400g",
        "producingArea": "进口",
        "imgName": "15.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 16,
        "name": "黄花鱼",
        "desc": "黄花鱼 黄鱼 700g/袋 2条装 火锅烧烤海鲜 大黄鱼 生鲜水产",
        "price0": 49.90,
        "price1": 49.90,
        "specification": "700g",
        "producingArea": "国产",
        "imgName": "16.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 17,
        "name": "金枪鱼",
        "desc": "金枪鱼刺身 生鲜 三文鱼刺身伴侣 生鱼片 4A级 500g",
        "price0": 128.90,
        "price1": 128.90,
        "specification": "500g",
        "producingArea": "进口",
        "imgName": "17.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 18,
        "name": "扇贝",
        "desc": "冷冻蒜蓉粉丝扇贝 200g/6只 虾夷扇贝 烧烤食材 自营海鲜水产",
        "price0": 21.90,
        "price1": 21.90,
        "specification": "200g",
        "producingArea": "国产",
        "imgName": "18.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 125142,
        "commentNum": 8753,
    },
    {
        "id": 19,
        "name": "白虾",
        "desc": "厄瓜多尔白虾南美大虾对虾",
        "price0": 109.90,
        "price1": 109.90,
        "specification": "1公斤",
        "producingArea": "进口",
        "imgName": "19.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 87142,
        "commentNum": 8753,
    },
    {
        "id": 20,
        "name": "鲍鱼",
        "desc": "冷冻福建鲍鱼10粒 去内脏 400-450g 袋装 海鲜水产烧烤火锅食材",
        "price0": 79.90,
        "price1": 75.90,
        "specification": "400-450g",
        "producingArea": "国产",
        "imgName": "20.jpg",
        "category": "海鲜水产",
        "brand": "鲜活之道",
        "saleNum": 75142,
        "commentNum": 8753,
    },
    {
        "id": 21,
        "name": "五花肉",
        "desc": "金锣 猪肉 猪带皮五花肉块 500g/袋 整肉原切",
        "price0": 32.90,
        "price1": 32.90,
        "specification": "500g",
        "producingArea": "国产",
        "imgName": "21.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 22,
        "name": "猪蹄",
        "desc": "蟹猪肉 猪蹄块 1kg/袋 原切精猪脚猪手 煲汤红烧酱卤食材",
        "price0": 66.90,
        "price1": 66.90,
        "specification": "1kg",
        "producingArea": "国产",
        "imgName": "22.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 23,
        "name": "牛扒",
        "desc": "手工整切牛排套餐10片进口S级牛肉微腌黑椒西冷菲力儿童牛扒 生鲜",
        "price0": 103.00,
        "price1": 99.90,
        "specification": "1kg",
        "producingArea": "进口",
        "imgName": "23.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 24,
        "name": "牛腩",
        "desc": "精品牛腩块 1kg 乌拉圭进口 草饲牛肉",
        "price0": 48.90,
        "price1": 48.90,
        "specification": "1kg",
        "producingArea": "进口",
        "imgName": "24.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 25,
        "name": "羊肉卷",
        "desc": "新西兰羔羊肉片 500g/袋 首农出品 羊排肉卷 火锅食材",
        "price0": 39.90,
        "price1": 39.90,
        "specification": "500g",
        "producingArea": "进口",
        "imgName": "25.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 26,
        "name": "羊肉串",
        "desc": "羊后腿肉串 200g/袋（约10串） 鲜冻羊肉串 烧烤食材",
        "price0": 49.90,
        "price1": 49.90,
        "specification": "200g",
        "producingArea": "国产",
        "imgName": "26.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 27,
        "name": "鸡翅根",
        "desc": "鸡翅根 1kg 鸡翅膀小鸡腿烤翅烤鸡翅 烧烤食材卤味卤煮食材",
        "price0": 39.90,
        "price1": 38.90,
        "specification": "1kg",
        "producingArea": "国产",
        "imgName": "27.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 28,
        "name": "鸡排",
        "desc": "鸡胸排 900g/袋 炸鸡排 炸鸡扒 鸡胸肉 鸡肉 适合油炸电烤",
        "price0": 35.90,
        "price1": 35.90,
        "specification": "900g",
        "producingArea": "国产",
        "imgName": "28.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 132142,
        "commentNum": 8753,
    },
    {
        "id": 29,
        "name": "鸭腿",
        "desc": "精切鸭腿 鸭全腿 600g/袋 瘦肉型樱桃谷鸭 酱卤鸭腿 烤鸭食材烧烤食材",
        "price0": 25.90,
        "price1": 24.90,
        "specification": "600g",
        "producingArea": "国产",
        "imgName": "29.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 105142,
        "commentNum": 8753,
    },
    {
        "id": 30,
        "name": "鸭胸",
        "desc": "鸭胸肉 新鲜鸭脯肉 西餐早餐食材 鸭胸肉 1140克",
        "price0": 49.90,
        "price1": 49.90,
        "specification": "1140g",
        "producingArea": "国产",
        "imgName": "30.jpg",
        "category": "精选肉类",
        "brand": "无肉不欢",
        "saleNum": 95152,
        "commentNum": 8753,
    },
    {
        "id": 31,
        "name": "饺子",
        "desc": "湾仔码头 速冻水饺 大白菜猪肉口味 720g （36只 早餐 火锅食材 烧烤 饺子）",
        "price0": 32.90,
        "price1": 32.90,
        "specification": "720g",
        "producingArea": "国产",
        "imgName": "31.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 32,
        "name": "汤圆",
        "desc": "黑芝麻汤圆 宁波风味 500g(约40只 早餐 火锅食材)",
        "price0": 10.90,
        "price1": 10.90,
        "specification": "500g",
        "producingArea": "国产",
        "imgName": "32.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 33,
        "name": "酸奶",
        "desc": "优益C 原味 340ml 活菌型乳酸菌饮品（3件起售）",
        "price0": 7.90,
        "price1": 7.90,
        "specification": "340ml",
        "producingArea": "国产",
        "imgName": "33.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 34,
        "name": "果汁",
        "desc": "冷冻冷藏饮料 冰杨梅汁 果蔬汁饮料 380ml*6瓶",
        "price0": 88.90,
        "price1": 86.90,
        "specification": "380ml*6瓶",
        "producingArea": "国产",
        "imgName": "34.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 35,
        "name": "酸奶",
        "desc": "老北京 风味酸奶 180g（5件起售）",
        "price0": 3.90,
        "price1": 3.90,
        "specification": "180g",
        "producingArea": "国产",
        "imgName": "35.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 36,
        "name": "蛋糕",
        "desc": "慕斯蛋糕 生日蛋糕同城配送 照红妆 6号食材",
        "price0": 199.90,
        "price1": 189.90,
        "specification": "2kg",
        "producingArea": "国产",
        "imgName": "36.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 37,
        "name": "牛奶",
        "desc": "鸡牧场原奶 新鲜纯牛奶 180ml*16袋/箱",
        "price0": 39.90,
        "price1": 38.90,
        "specification": "180ml*6袋",
        "producingArea": "国产",
        "imgName": "37.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 38,
        "name": "冰激凌",
        "desc": "双重脆层流心酱红覆盆子口味 冰淇淋家庭装 216g 雪糕",
        "price0": 42.90,
        "price1": 33.90,
        "specification": "400g",
        "producingArea": "国产",
        "imgName": "38.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 125142,
        "commentNum": 8753,
    },
    {
        "id": 39,
        "name": "芝士",
        "desc": "百吉福芝士片家庭装香浓原味300g分享装（18片装）汉堡三明治烘焙辅材",
        "price0": 27.90,
        "price1": 27.90,
        "specification": "300g",
        "producingArea": "国产",
        "imgName": "39.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 95762,
        "commentNum": 8753,
    },
    {
        "id": 40,
        "name": "蛋挞",
        "desc": "牛油蛋挞皮 1020g 51个装烘焙食材 蛋挞烘焙原料（新老包装随机发货）",
        "price0": 26.90,
        "price1": 26.90,
        "specification": "1140g",
        "producingArea": "国产",
        "imgName": "40.jpg",
        "category": "冷饮冻食",
        "brand": "冰雪奇缘",
        "saleNum": 85142,
        "commentNum": 8753,
    },
    {
        "id": 41,
        "name": "鲜笋",
        "desc": "春笋 笋 2.5kg 新鲜雷笋竹笋笋尖鲜笋 非冬笋 新鲜蔬菜",
        "price0": 35.90,
        "price1": 32.90,
        "specification": "2.5kg",
        "producingArea": "国产",
        "imgName": "41.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 42,
        "name": "地瓜",
        "desc": "海南澄迈桥头富硒地瓜 板栗红薯 番薯 约2.5kg 新鲜蔬菜",
        "price0": 28.00,
        "price1": 26.90,
        "specification": "2.5kg",
        "producingArea": "国产",
        "imgName": "42.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 43,
        "name": "圣女果",
        "desc": "圣女果 小番茄 樱桃番茄约500g 新鲜蔬菜",
        "price0": 19.90,
        "price1": 19.90,
        "specification": "500g",
        "producingArea": "国产",
        "imgName": "43.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 44,
        "name": "油菜",
        "desc": "上海青 小油菜 小青菜 约400g 火锅食材 新鲜蔬菜",
        "price0": 6.90,
        "price1": 6.90,
        "specification": "500g",
        "producingArea": "国产",
        "imgName": "44.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 45,
        "name": "大白菜",
        "desc": "白菜 约1kg 火锅食材 新鲜蔬菜",
        "price0": 9.90,
        "price1": 9.90,
        "specification": "1000g",
        "producingArea": "国产",
        "imgName": "45.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 46,
        "name": "洋葱",
        "desc": "红洋葱 约500g 烧烤食材 新鲜蔬菜",
        "price0": 5.90,
        "price1": 5.90,
        "specification": "500g",
        "producingArea": "国产",
        "imgName": "46.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 47,
        "name": "甜玉米",
        "desc": "云南甜玉米 水果玉米 约2.5kg 6-9根 烧烤食材 新鲜蔬菜",
        "price0": 29.90,
        "price1": 28.90,
        "specification": "2.5kg",
        "producingArea": "国产",
        "imgName": "47.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 45142,
        "commentNum": 8753,
    },
    {
        "id": 48,
        "name": "西红柿",
        "desc": "西红柿 番茄 粉茄 约1.25kg 新鲜蔬菜",
        "price0": 22.90,
        "price1": 22.90,
        "specification": "1.25kg",
        "producingArea": "国产",
        "imgName": "48.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 10142,
        "commentNum": 8753,
    },
    {
        "id": 49,
        "name": "土豆",
        "desc": "荷兰土豆 洋芋 约1kg 火锅食材 新鲜蔬菜",
        "price0": 9.90,
        "price1": 9.90,
        "specification": "1000g",
        "producingArea": "国产",
        "imgName": "49.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 75142,
        "commentNum": 8753,
    },
    {
        "id": 50,
        "name": "黄瓜",
        "desc": "5斤现摘水果小黄瓜 迷你黄瓜 青瓜白玉黄瓜 水果小青瓜沙拉菜特产蔬菜",
        "price0": 36.90,
        "price1": 36.90,
        "specification": "5斤",
        "producingArea": "国产",
        "imgName": "50.jpg",
        "category": "蔬菜蛋品",
        "brand": "鲜菜篮子",
        "saleNum": 65902,
        "commentNum": 8753,
    },
];


//////////////////
// WEBPACK FOOTER
// ./static/products.js
// module id = null
// module chunks = 